import { Box, Typography, Button, Stack, ButtonBase } from "@mui/material";
const Logo = `${process.env.PUBLIC_URL || ""}/apple-touch-icon.png`;

export default function DrawerHeader({ isAuthed, username, onOpenLogin, onNavigate }) {
  return (
    <Box
      sx={{
        position: "relative",
        px: 2.5,
        pt: 3.5,
        pb: 2.8,
        backgroundImage:
          "radial-gradient(circle at 20% 0%, rgba(255,255,255,0.10), transparent 60%)",
        borderBottom: "1px solid rgba(255,255,255,0.10)",
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: isAuthed ? 1.5 : 2 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={Logo}
            alt="Creative Insights"
            sx={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box>
        <Box>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1rem",
              lineHeight: 1.1,
              color: "surfaces.onDark",
              letterSpacing: "-0.01em",
            }}
          >
            Creative Insights
          </Typography>
          <Typography
            sx={{
              fontSize: "0.72rem",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.5)",
              mt: 0.2,
            }}
          >
            Mat &amp; näring
          </Typography>
        </Box>
      </Stack>

      {isAuthed ? (
        <ButtonBase
          onClick={() => onNavigate?.("/dashboard")}
          sx={{
            display: "block",
            width: "100%",
            textAlign: "left",
            px: 1.25,
            py: 0.75,
            mx: -1.25,
            borderRadius: 2,
            transition: "background-color .2s ease",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.06)",
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "0.68rem",
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.45)",
              mb: 0.3,
            }}
          >
            Inloggad
          </Typography>
          <Typography
            sx={{
              fontSize: "0.82rem",
              fontWeight: 600,
              color: "surfaces.onDark",
              lineHeight: 1.2,
            }}
          >
            <Box component="span" sx={{ opacity: 0.5, mr: 0.25 }}>@</Box>
            {username}
          </Typography>
        </ButtonBase>
      ) : (
        <Button
          onClick={onOpenLogin}
          fullWidth
          sx={{
            color: "surfaces.onDark",
            border: "1px solid rgba(255,255,255,0.25)",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.9rem",
            py: 0.9,
            borderRadius: 2,
            "&:hover": {
              color: "accent.main",
              borderColor: "accent.main",
              backgroundColor: "rgba(255,255,255,0.06)",
            },
          }}
        >
          Logga in
        </Button>
      )}
    </Box>
  );
}

